// Dependencies
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ReviewFormModel", {
    enumerable: true,
    get: function() {
        return ReviewFormModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const ReviewFormModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    base_id: _zod.z.instanceof(_bson.ObjectId),
    company: _zod.z.instanceof(_bson.ObjectId),
    creator: _zod.z.instanceof(_bson.ObjectId),
    created_at: _utilsisomorphic.transformDate.nullish(),
    updated_by: _zod.z.instanceof(_bson.ObjectId).nullish(),
    updated_at: _utilsisomorphic.transformDate.nullish(),
    deleted_at: _utilsisomorphic.transformDate.nullish(),
    deleted_by: _zod.z.instanceof(_bson.ObjectId).nullish(),
    goal_creation: _zod.z.boolean().optional(),
    goal_discussion: _zod.z.boolean().optional(),
    name: _zod.z.string(),
    questions: _zod.z.array(_zod.z.instanceof(_bson.ObjectId))
});
